// @flow
import NumberFormat from 'react-number-format';

import CheckoutErrors from '@components/cart/CheckoutErrors';

const checkmarkIcon = '/images/checkout_checkmark_icon.png';

type RefType = {
  current: null | React.ElementRef<'input'>
};

type ErrorFieldType = string;

type PropsType = {
  onSubmitClick: (fields: Object, allowNext?: boolean) => void,
  editStep: (e: SyntheticMouseEvent<HTMLLinkElement>, name: string) => void,
  active: boolean,
  completed: boolean,
  stepName: string,
  errorFields: Array<ErrorFieldType>
};

class CheckoutStepOne extends React.Component<PropsType> {
  firstNameRef: RefType;
  lastNameRef: RefType;
  emailRef: RefType;
  phoneRef: RefType;
  allRefs: Array<RefType>;

  constructor (props: PropsType) {
    super(props);

    this.firstNameRef = React.createRef();
    this.lastNameRef = React.createRef();
    this.emailRef = React.createRef();
    this.phoneRef = React.createRef();
    this.allRefs = [
      this.firstNameRef,
      this.lastNameRef,
      this.emailRef,
      this.phoneRef
    ];
  }

  handleButtonClick = (e: SyntheticMouseEvent<HTMLInputElement>) => {
    e.preventDefault();

    const fields = {};

    this.allRefs.forEach((ref: RefType) => {
      const el = ref.current;
      if (!el || !el.name) {
        return;
      }

      fields[(el.name.match(/order\[(.*)\]/) || [])[1]] = el.value;
    });

    this.props.onSubmitClick({ order: fields });
  };

  render () {
    const {
      active,
      completed,
      onSubmitClick,
      editStep,
      stepName,
      errorFields
    } = this.props;

    return (
      <div id="checkoutBox">
        <h3>
          <img
            alt="Checkmark_icon"
            id="basic_checked"
            src={checkmarkIcon}
            style={{ display: completed ? 'block' : 'none' }}
          />
          Your Personal Information:
          <a
            href="#"
            id="basic_edit_link"
            style={{ display: completed ? 'block' : 'none' }}
            onClick={(e) => editStep(e, stepName)}>
            edit
          </a>
        </h3>
        <div id="checkoutContent">
          <div
            id="basic_checkout"
            style={{ display: active ? 'block' : 'none' }}>
            <dl>
              <div>
                <dt>
                  <label htmlFor="order_first_name">First Name:</label>
                </dt>
                <dd>
                  <input
                    autoComplete="given-name"
                    id="order_first_name"
                    name="order[first_name]"
                    size={30}
                    type="text"
                    ref={this.firstNameRef}
                  />
                </dd>
                <dd>
                  We don't want to spoil any surprise. Enter an email and phone
                  where we or FedEx may contact you if necessary.
                </dd>
              </div>
              <div>
                <dt>
                  <label htmlFor="order_last_name">Last Name:</label>
                </dt>
                <dd>
                  <input
                    autoComplete="family-name"
                    id="order_last_name"
                    name="order[last_name]"
                    size={30}
                    type="text"
                    ref={this.lastNameRef}
                  />
                </dd>
              </div>
              <div>
                <dt>
                  <label htmlFor="order_email">Email:</label>
                </dt>
                <dd>
                  <input
                    autoComplete="email"
                    id="order_email"
                    name="order[email]"
                    size={30}
                    type="email"
                    ref={this.emailRef}
                  />
                </dd>
              </div>
              <div>
                <dt>
                  <label htmlFor="order_phone_number">Phone:</label>
                </dt>
                <dd>
                  <NumberFormat
                    type="tel"
                    format="(###) ###-####"
                    mask="_"
                    id="order_phone_number"
                    autoComplete="home mobile work tel"
                    name="order[phone_number(1s)]"
                    size={30}
                    getInputRef={(el) => {
                      this.phoneRef.current = el;
                    }}
                  />
                </dd>
              </div>
            </dl>
            <input
              className="blue button"
              defaultValue="Enter"
              type="button"
              onClick={this.handleButtonClick}
            />
            <br />
            <br />
            <CheckoutErrors errorFields={errorFields} />
            <input
              id="order_step"
              name="order[step]"
              defaultValue="basic"
              type="hidden"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CheckoutStepOne;
